import React, { useState } from 'react';
import { Button } from "src/components/Component";
import {
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { Auth } from "aws-amplify";
import axios from 'axios';
import API_ROUTES from 'src/config/api';
import { useSelector } from 'react-redux';

import { PaintBrushIcon, XMarkIcon } from '@heroicons/react/24/outline';

const LedgerAmendment = ({ triggerReload }) => {
  const { organisation } = useSelector((state) => state);

  const [modalForm, setModalForm] = useState(false);
  const [modalFormProcessing, setModalFormProcessing] = useState(false);

  const [formValues, setFormValues] = useState({
    type: '',
    amount: '',
    reason: '',
  });

  // Toggle form
  const toggleForm = () => {
    setModalForm(!modalForm);

    if (!modalForm) {
      setFormValues({
        type: '',
        amount: '',
        reason: '',
      });
    }
  };

  // Update form values
  const updateFormValues = (ev) => {
    const { name, value } = ev.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  }

  // Check if form is valid
  const formValid = formValues.type !== '' && formValues.amount !== '' && formValues.reason !== '';

  const submitForm = async (ev) => {
    ev.preventDefault();

    setModalFormProcessing(true);

    const user = await Auth.currentAuthenticatedUser();

    await axios.put(
      API_ROUTES.ledger['ledger:amendment'](),
      {
        ...formValues,
        organisation: organisation.organisation,
      },
      {
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    // Submit form
    setModalFormProcessing(false);
    setModalForm(false);
    triggerReload()
  };

  return (
    <React.Fragment>
      <button className="btn bg-white hover:text-red-900 text-red-700 border border-red-700 float-left ml-2" onClick={toggleForm}>
        <PaintBrushIcon className="h-5 w-5 mr-2" />
        Create Ledger Amendment
      </button>

      <Modal isOpen={modalForm} toggle={toggleForm}>
        <ModalHeader
          toggle={toggleForm}
          className="bg-red-500 text-white text-xl font-bold"
          close={
            <button className="close" onClick={toggleForm}>
              <XMarkIcon className="text-white" />
            </button>
          }
        >
          Create Ledger Amendment
        </ModalHeader>

        <ModalBody>
          <p className='mb-2'>Type <span className='text-red-500 text-xs'>(required)</span></p>
          <div className='flex mb-4'>
            <div className="w-50 mr-2 flex items-center ps-4 border border-gray-200 rounded dark:border-gray-700">
              <input
                id="bordered-radio-1"
                type="radio"
                defaultValue={formValues.type}
                name="type"
                value={'credit'}
                onChange={updateFormValues}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                htmlFor="bordered-radio-1"
                className="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Credit
              </label>
            </div>

            <div className="ml-2 w-50 flex items-center ps-4 border border-gray-200 rounded dark:border-gray-700">
              <input
                defaultChecked=""
                id="bordered-radio-2"
                type="radio"
                defaultValue="debit"
                name="type"
                value={'debit'}
                onChange={updateFormValues}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                htmlFor="bordered-radio-2"
                className="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Debit
              </label>
            </div>

          </div>

          <p className='mb-2'> Amount <span className='text-red-500 text-xs'>(required)</span></p>
          <FormGroup>
            <div className={`form-control-wrap input-group`}>
              <div className="input-group-addon pl-3 pr-3">£</div>
              <input
                type="text"
                id="amount"
                name="amount"
                onChange={updateFormValues}
                value={formValues.amount}
                placeholder="e.g. 1523"
                className="form-control form-control-xl"
              />
            </div>
          </FormGroup>

          <p className='mb-2'> Reason <span className='text-red-500 text-xs'>(required)</span></p>
          <FormGroup>
            <div className="form-control-wrap">
              <textarea
                id="bookingref"
                name="reason"
                placeholder="e.g. Ammendment due to Chris making a mistake"
                className="form-control form-control-xl"
                onChange={updateFormValues}
                value={formValues.reason}
              />
            </div>
          </FormGroup>

        </ModalBody>

        <ModalFooter className="bg-light">
          <FormGroup>
            <Button 
              className="bg-red-600 hover:bg-red-800 text-white" 
              type="submit" disabled={modalFormProcessing || formValid === false} 
              onClick={submitForm}
              size="lg"
            >
              {modalFormProcessing ? <Spinner size="sm" color="light"> </Spinner> : 'Create Ledger Amendment'}
            </Button>
          </FormGroup>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}

export default LedgerAmendment;
